<template>
  <el-collapse v-model="activePanel">
    <el-collapse-item title="買付先メモ" name="1">
      <template v-for="(shopNote, index) in shopNotes">
        <div :key="shopNote.seqNo">
          <el-divider v-if="index > 0"></el-divider>
          <el-row style="margin-bottom: 10px">
            <el-col :span="4" style="padding-top: 7px; padding-right: 10px; text-align: right;">
              <span>買付先名</span>
            </el-col>
            <el-col :span="18">
              <input-text v-model="shopNote.label" :limit-length="30">
              </input-text>
            </el-col>
            <el-col :span="2" style="padding-top: 3px; padding-left: 5px;">
              <el-button type="text"
                        icon="el-icon-delete"
                        @click="removeShopNote(index)">
              </el-button>
            </el-col>
          </el-row>
          <el-row style="margin-bottom: 10px">
            <el-col :span="4" style="padding-top: 7px; padding-right: 10px; text-align: right;">
              <span>URL</span>
            </el-col>
            <el-col :span="18">
              <input-text v-model="shopNote.url" :limit-length="2000">
              </input-text>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="4" style="padding-top: 7px; padding-right: 10px; text-align: right;">
              <span>説明</span>
            </el-col>
            <el-col :span="18">
              <input-text v-model="shopNote.description" :limit-length="200">
              </input-text>
            </el-col>
          </el-row>
        </div>
      </template>
      <el-row style="margin-top: 5px">
        <el-col>
          <el-button type="text" @click="addShopNote">買付先メモ 追加</el-button>
        </el-col>
      </el-row>
    </el-collapse-item>
  </el-collapse>
</template>

<script>
import InputText from '@/components/InputText.vue'

export default {
  name: 'ShopNote',
  components: {
    inputText: InputText
  },
  model: {
    prop: 'shopNotes',
    event: 'change'
  },
  props: {
    shopNotes: {
      type: Array
    }
  },
  data: function () {
    return {
      activePanel: ['1']
    }
  },
  methods: {
    addShopNote: function () {
      this.shopNotes.push({
        seqNo: this.shopNotes.length + 1,
        label: '',
        url: '',
        description: ''
      })
    },
    removeShopNote: function (index) {
      this.shopNotes.splice(index, 1)
      for (let no = 1; no <= this.shopNotes.length; no++) {
        this.shopNotes[no - 1].seqNo = no
      }
    }
  }
}
</script>
